import {stripZeros, TitleAndQuickDetails} from 'Shared/frontend/menuPage/CardItem';
import { css } from '@emotion/css';
import { createSignal, For, onCleanup, Show } from 'solid-js';
import { capitalise } from 'Shared/common/Capitalise';
import { theme, palette } from 'Shared/frontend/SettingsProvider';
import { isServer } from 'solid-js/web';
import { onMount } from 'solid-js';

//XXX NB StandardMenuItem is using this to flip to mobile
export const singleColumn = 745;

const itemStyle = () => css({
	width: '100%',
	margin: '0 auto',
    backgroundColor: palette().background
})

const detailsStyle = () => css({
	paddingBottom: '2em',
});

const topLineStyle = () => css({
	display: 'flex',
	flexDirection: 'row',
	/*
		Probably doesnt work so well when the top line wraps - 
		would rather have the price line up with the top line.
	*/
	alignItems: 'stretch',
	marginBottom: '0.5em'
});

/*
	The sizes below were 1.1em and 1em of whatever the menu section inherited, which was page().root's
	hard-coded 15px on every venue until root took its size from the venue 'Plain text' style. They are
	the px those ems resolved to at 15px - a venue that wants its menu read larger sizes it from a
	Style Builder rule now rather than by moving the whole site's body text. See smallStyle below for
	what the item name's small print resolves to off the 16.5px.
*/
const titleAndQuickDetailsStyle = () => css({
	textTransform: 'uppercase',
	fontSize: '16.5px',  //XXX fold title style into here??
});

//TODO ben review this code, it's likely bloated. CJ only added to make two flex changes on PricesNarrow
const narrowTitleAndQuickDetailsStyle = () => css({
	textTransform: 'uppercase',
	fontSize: '16.5px',  //XXX fold title style into here??
	textAlign: 'left',
});

const fillerStyle = () => css({
	flex: '1 1',
	width: '99%',
	background: 'radial-gradient(circle at 50% 72%, #999 3%, transparent 3%)',
	backgroundSize: '0.5em',
	backgroundRepeat: 'repeat-x',
});

const descriptionStyle = () => css({
	fontSize: '15px',
	marginBottom: '0.5em',
	textAlign: 'left'
});

/* 0.7em of the 16.5px title line an item name sits on - the size CardItem's own smallStyle came to
   when TitleAndQuickDetails was rendered by an imageless item rather than a card. */
const smallStyle = () => css({
	fontSize: '11.55px'
});

const priceInnerStyle = () => css({
	alignSelf: 'flex-end',
	textAlign: 'right !important'
});

const priceWrapStyle = () => css({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'flex-start',
	justifyContent: 'flex-end',
	gap: '1ch',

	...theme().item.price
});

//TODO ben review this code, it's likely bloated. CJ only added to make two flex changes on PricesNarrow
const narrowPriceWrapStyle = () => css({
	display: 'flex',
	flexDirection: 'column', //wide = 'row',
	alignItems: 'flex-start',
	justifyContent: 'flex-end',
	gap: 'och', //wide = '1ch',

	...theme().item.price
});

const unitStyle = () => css({});


export function ImagelessItem(props)
{
	//XXX maybe creater a helper for this. Share with eventPage/Artist.tsx
	const [wide,setWide] = createSignal(isServer ? true : undefined);

	onMount(() => {
		setWide(window.innerWidth >= singleColumn && !props.isPreview);

		const widthHandler = () => setWide(window.innerWidth >= singleColumn && !props.isPreview);
		window.addEventListener('resize', widthHandler);
		onCleanup(() => window.removeEventListener('resize', widthHandler));
	});

	return (<>
		<div class={itemStyle()}>
			<div class={detailsStyle()}>
				{wide() ? <WideItem {...props} /> : <NarrowItem {...props} />}
			</div>
		</div>
	</>);
}

function WideItem(props)
{
	return (<>
		<div class={topLineStyle()}>
			<div class={titleAndQuickDetailsStyle()}>
				<TitleAndQuickDetails item={props.item} smallClass={smallStyle()} />
			</div>

			{/* Used for dot leaders etc */}
			<div class={fillerStyle()} />

			<Prices item={props.item}/>
		</div>

		<div class={descriptionStyle()}>
			{props.item.tagline}
		</div>
	</>);
}

function NarrowItem(props)
{
	return (<>
		<div class={narrowTitleAndQuickDetailsStyle()}>
			<TitleAndQuickDetails item={props.item} smallClass={smallStyle()} />
		</div>

		<div class={descriptionStyle()}>
			{props.item.tagline}
		</div>
		<PricesNarrow item={props.item}/>
	</>);
}

function Prices(props)
{
	return (
		<div class={priceWrapStyle()}>
			<For each={props.item.prices}>{ unit =>
				<Show when={unit.price !== null }>
					{/* XXX probably shouldnt be required but currently these items contain nulls */}
					<div class={priceInnerStyle()}>
						{/* Only 1 of these unit options will appear */}
						<span class={unitStyle()}>{capitalise(unit.size)}{capitalise(unit.description)}{' '}</span>
						<span>${stripZeros(unit.price)}</span>
					</div>
				</Show>
			}</For>
		</div>
	);
}

//TODO ben review CJ added, there's probably easier simpler way to implement priceWrapNarrowStyle
function PricesNarrow(props)
{
	return (
		<div class={narrowPriceWrapStyle()}>
			<For each={props.item.prices}>{ unit =>
				<Show when={unit.price !== null }>
					{/* XXX probably shouldnt be required but currently these items contain nulls */}
					<div class={priceInnerStyle()}>
						{/* Only 1 of these unit options will appear */}
						<span class={unitStyle()}>{capitalise(unit.size)}{capitalise(unit.description)}{' '}</span>
						<span>${stripZeros(unit.price)}</span>
					</div>
				</Show>
			}</For>
		</div>
	);
}

